const THEME_KEY = "theme";

export const themes = {
  LIGHT: "light",
  DARK: "dark",
};

export const getStoredTheme = () => {
  try {
    return localStorage.getItem(THEME_KEY) || themes.DARK;
  } catch {
    return themes.DARK;
  }
};

export const setStoredTheme = (theme) => {
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch (error) {
    console.error("Failed to store theme preference:", error);
  }
};

export const getEffectiveTheme = (theme) => {
  return theme;
};

export const applyTheme = (theme) => {
  const effectiveTheme = getEffectiveTheme(theme);
  
  // Force immediate update by temporarily disabling transitions
  const style = document.createElement('style');
  style.innerHTML = `
    *, *::before, *::after {
      transition: none !important;
      animation-duration: 0s !important;
      animation-delay: 0s !important;
    }
  `;
  document.head.appendChild(style);
  
  document.documentElement.setAttribute("data-theme", effectiveTheme);
  
  // Force a reflow to apply changes immediately
  // eslint-disable-next-line no-unused-expressions
  document.documentElement.offsetHeight;
  
  // Re-enable transitions after applying the theme
  setTimeout(() => {
    document.head.removeChild(style);
  }, 50);
};

export const initializeTheme = () => {
  const theme = getStoredTheme();
  applyTheme(theme);
};

export const toggleTheme = () => {
  const currentTheme = document.documentElement.getAttribute("data-theme") || themes.DARK;
  const newTheme = currentTheme === themes.LIGHT ? themes.DARK : themes.LIGHT;
  applyTheme(newTheme);
  setStoredTheme(newTheme);
  return newTheme;
};